import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-50 mb-4">漫境</h3>
            <p className="text-sm leading-relaxed text-foreground-400">
              为成年读者打造的精选漫画阅读空间。正版授权，安全私密。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/xuan-yi-jing-song" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/xuan-yi-jing-song" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">悬疑惊悚</Link></li>
              <li><Link to="/category/du-shi-qing-gan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">都市情感</Link></li>
              <li><Link to="/category/li-shi-chuan-qi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">历史传奇</Link></li>
              <li><Link to="/category/ke-huan-qi-huan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">科幻奇幻</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li>contact@manga-realm.readdy.ai</li>
              <li>上海市静安区南京西路1788号</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 漫境 Manga Realm. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
            <a href="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}